import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ServerRootService } from '@se/platform';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class SendingApplicationService extends ServerRootService {
    private readonly endPoint = '/Vna/GetSendingApplication';
    private readonly url = this.getServerRoot() + this.endPoint;

    constructor(private httpClient: HttpClient) {
        super();
    }

    //vedere se passare param
    getIsses(isType: string): Observable<Array<string>> {
        const params = new HttpParams().set('isType', isType);
        return this.httpClient.get<Array<string>>(this.url, {
            params: params,
        });
    }
}
